import React, { useEffect, useState } from 'react'
import './AdminDashboardAdvertisers.css';
import { Outlet } from 'react-router-dom';

export default function AdminDashboardAdvertisers() {

  
  return (
    <div className='adminDashboardContainer'>
      <div className='adminDashboardScreenPageContainer'>
      <Outlet  />
      </div>
    </div>
  )
}
